<template>
  <base-card info v-if="!$auth.user.hasVerifiedEmail">
    <template v-slot:header>
      <base-card-heading>Verify Email Address</base-card-heading>
      <base-icon class="bg-white rounded-circle text-danger" icon="exclamation-circle"/>
    </template>
    We need to verify your email address, please check your inbox for a verification email.
  </base-card>
</template>

<script>
export default {
  name: 'VerifyEmail'
}
</script>
